// extracted by mini-css-extract-plugin
export default {"slideAlert":"SlideAlert_slideAlert__w+WU8","fadeInOut":"SlideAlert_fadeInOut__4LbIo"};